import React from 'react';
import { Box, Typography } from '@mui/material';
import { initials } from '../helpers';
import { launchColors } from '../launchTheme';

interface Props {
  name: string;
  role?: string;
  size?: number;
  showName?: boolean;
  unassigned?: boolean;
}

const PersonAvatar: React.FC<Props> = ({ name, role, size = 28, showName = true, unassigned = false }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
    <Box
      aria-hidden
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: Math.round(size * 0.4),
        fontWeight: 700,
        color: unassigned ? launchColors.textSecondary : launchColors.navy,
        bgcolor: unassigned ? launchColors.card : launchColors.softNavy,
        border: unassigned ? `1px dashed ${launchColors.textMuted}` : 'none',
      }}
    >
      {unassigned ? '?' : initials(name)}
    </Box>
    {showName && (
      <Box sx={{ minWidth: 0 }}>
        <Typography noWrap sx={{ fontSize: 13, fontWeight: 600, color: unassigned ? launchColors.textSecondary : launchColors.text, lineHeight: 1.3 }}>{name}</Typography>
        {role && <Typography noWrap sx={{ fontSize: 12, color: launchColors.textSecondary, lineHeight: 1.3 }}>{role}</Typography>}
      </Box>
    )}
  </Box>
);

export default PersonAvatar;
